import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import usePut from "../usePut";
import { roundToTwoDecimalPlaces } from "../../utility/utils";

const useAddEditSalaryTemplate = ({
  onTemplateAdded,
  onTemplateEdited,
  template,
} = {}) => {
  const { control, setValue, handleSubmit } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const { handleAuth: createReq } = usePut({
    url: "template-salary-structure/create",
    refreshUrl: [
      "template-salary-structure/list",
      "dashboard/company_completion_status",
      "is_permission_for_product",
    ],
    onSuccess: (data) => {
      toast.success("Template added successfully");
      if (onTemplateAdded) onTemplateAdded(data);
    },
    onError: (error) => {
      toast.error("Failed to add template: " + error?.message);
    },
  });
  const isAdding = createReq.isLoading;

  const addTemplate = (data) => {
    createReq.mutate({
      ...data,
      monthly_ctc: roundToTwoDecimalPlaces(parseFloat(data.annual_ctc) / 12),
    });
  };

  const onFormError = () => {
    toast.error("Please fill in the template name");
  };

  const { handleAuth: editReq } = usePut({
    url: "template-salary-structure/update",
    refreshUrl: ["template-salary-structure/list"],
    onSuccess: (data) => {
      toast.success("Template updated successfully");
      if (onTemplateEdited) onTemplateEdited(data);
    },
    onError: (error) => {
      toast.error("Failed to update template: " + error?.message);
    },
  });
  const isEditing = editReq.isLoading;

  const editTemplate = (data) => {
    editReq.mutate({ ...data, template_id: template.template_id });
  };

  return {
    control,
    setValue,
    handleSubmit,
    addTemplate,
    isAdding,
    onFormError,
    editTemplate,
    isEditing,
  };
};

export default useAddEditSalaryTemplate;
